import {useState} from 'react';

import {Menu, MenuItem, Typography} from '@mui/material';
import Box from '@mui/material/Box';
import {bool, element, func, node, object, oneOf, oneOfType, shape, string} from 'prop-types';

import {FONT_FAMILIES} from '../../const';
import SearchBar from '../form/SearchBar/SearchBar';

// eslint-disable-next-line react/prop-types
const OverflowedTabsMenu = ({tabs, onItemSelect, anchorEl, isOpen, onClose, entityName}) => {
  const [search, setSearch] = useState('');

  const filtered = (tabs || []).filter(t => t.label.toLowerCase().includes(search.toLowerCase()));

  return (
    <Menu
      anchorEl={anchorEl}
      open={isOpen}
      onClose={onClose}
      PaperProps={{sx: {width: 300}}}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      transformOrigin={{vertical: 'top', horizontal: 'right'}}
    >
      <Box mt={1} mb={2} px={1}>
        <SearchBar placeholder={`Recherchez un ${entityName}...`} value={search} setValue={setSearch} />
      </Box>

      {filtered.map(item => (
        <MenuItem
          key={item.value}
          onClick={() => {
            onItemSelect(item.value);
            onClose();
          }}
        >
          <Typography noWrap fontFamily={FONT_FAMILIES.TITLE} color="primary">
            {item.label}
          </Typography>
        </MenuItem>
      ))}

      {filtered.length === 0 && (
        <Typography fontSize={14} color="text.secondary" ml={1} px={1.5}>
          Aucun {entityName} ne correspond à vos critères...
        </Typography>
      )}
    </Menu>
  );
};

export default OverflowedTabsMenu;
